// Колокольчик с числом непрочитанных. Живёт в полосе разделов рядом с выходом: одно место,
// куда человек идёт с вопросом «что случилось, пока меня не было».
//
// Число рисуется, только когда оно больше нуля. Пустой значок «0» — это шум, который через
// неделю перестают замечать вместе с настоящими уведомлениями.

import { RiNotification3Line } from '@remixicon/react';
import { useLocation, useNavigate } from 'react-router';

import { buildSearch, parseSearch, pushPanel } from '@/shared/routing/search';
import { cn } from '@/utils/cn';

import { PANEL_NOTIFICATIONS } from './register';
import { useUnreadCount } from './queries';

export function NotificationsBell() {
  const непрочитано = useUnreadCount();
  const location = useLocation();
  const navigate = useNavigate();

  const открыть = () => {
    const state = pushPanel(parseSearch(location.search), {
      view: PANEL_NOTIFICATIONS,
      id: 'all',
    });
    navigate(`${location.pathname}${buildSearch(state)}`);
  };

  return (
    <button
      type='button'
      onClick={открыть}
      aria-label={непрочитано > 0 ? `Уведомления, непрочитанных ${непрочитано}` : 'Уведомления'}
      title='Уведомления'
      className={cn(
        'цель-тача relative flex size-8 shrink-0 items-center justify-center rounded-lg transition duration-200 ease-out',
        'text-text-sub-600 hover:bg-bg-weak-50 hover:text-text-strong-950',
      )}
    >
      <RiNotification3Line className='size-5' />
      {непрочитано > 0 ? (
        <span
          className='absolute -right-0.5 -top-0.5 flex min-w-4 items-center justify-center rounded-full bg-primary-base px-1 text-subheading-2xs text-static-white'
          aria-hidden='true'
        >
          {непрочитано > 99 ? '99+' : непрочитано}
        </span>
      ) : null}
    </button>
  );
}
